export const MORPH_DURATION_MS = 360;
export const MORPH_DURATION_S = MORPH_DURATION_MS / 1000;
